import React, {useCallback, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import useCancelToken from '../../../../../../_gori/hooks/UseCancelToken'
import SettingsService from '../../../core/_requests'
import {MOBILE_MAX_WIDTH, WEIGHT_UNIT} from '../../../../../../_gori/constants'
import clsx from 'clsx'
import useWindowDimensions from '../../../../../../_gori/hooks/useWindowDimensions'

const ReportSettingModal = () => {
  const intl = useIntl()
  const {newCancelToken} = useCancelToken()
  const [defaultWeightUnit, setDefaultWeightUnit] = useState<any>([])
  const {width} = useWindowDimensions()
  const getSettings = useCallback(async () => {
    try {
      const settings = await SettingsService.settings({cancelToken: newCancelToken()})
      setDefaultWeightUnit(settings?.report?.weight_unit)
    } catch (error) {
      console.error(error)
    }
  }, [newCancelToken])

  useEffect(() => {
    getSettings()
  }, [getSettings])

  const handleSelect = async (unit: string, getSettings) => {
    setDefaultWeightUnit(unit)
    try {
      const config = {cancelToken: newCancelToken()}
      const payload = {
        weight_unit: unit,
      }
      const res = await SettingsService.updateReport(payload, config)
      if (res) {
        await getSettings
        toast.success(intl.formatMessage({id: 'UPDATED_SUCCESSFULLY'}))
      }
    } catch (error: any) {
      console.error('Failed to update weight unit:', error)
      toast.error(intl.formatMessage({id: 'UPDATE_FAILED'}))
    }
  }

  return (
    <div
      className={clsx('d-flex w-100', {
        'flex-column gap-2': width <= MOBILE_MAX_WIDTH,
        'flex-row': width > MOBILE_MAX_WIDTH,
      })}
    >
      {/* Left Column: Label */}
      <div
        className={clsx('col-6 col-sm-4 fw-bold setting-label', {
          'align-self-center': width > MOBILE_MAX_WIDTH,
        })}
      >
        {intl.formatMessage({id: 'DEFAULT_WEIGHT_UNIT'})}
      </div>
      {/* Right Column: Weight Unit Selection */}
      <div
        className={clsx('col-6 col-sm-8 fw-bolder', {
          'w-100': width <= MOBILE_MAX_WIDTH,
        })}
      >
        <div className='d-flex flex-wrap gap-3'>
          <div
            className={`d-flex flex-column align-items-start justify-content-center box ${
              defaultWeightUnit === WEIGHT_UNIT.OZ ? 'selected' : ''
            }`}
            onClick={() => handleSelect(WEIGHT_UNIT.OZ, getSettings)}
          >
            <div className={`TextBox d-flex flex-wrap align-items-center`}>
              <div className={`selectionBoxText`}>{intl.formatMessage({id: 'OUNCES'})}</div>
            </div>
          </div>
          <div
            className={`d-flex flex-column align-items-start justify-content-center box ${
              defaultWeightUnit === WEIGHT_UNIT.LB ? 'selected' : ''
            }`}
            onClick={() => handleSelect(WEIGHT_UNIT.LB, getSettings)}
          >
            <div className={`TextBox d-flex flex-wrap align-items-center`}>
              <div className={`selectionBoxText`}>{intl.formatMessage({id: 'POUNDS'})}</div>
            </div>
          </div>
          <div
            className={`d-flex flex-column align-items-start justify-content-center box ${
              defaultWeightUnit === WEIGHT_UNIT.KG ? 'selected' : ''
            }`}
            onClick={() => handleSelect(WEIGHT_UNIT.KG, getSettings)}
          >
            <div className={`TextBox d-flex flex-wrap align-items-center`}>
              <div className={`selectionBoxText`}>{intl.formatMessage({id: 'KILOGRAMS'})}</div>
            </div>
          </div>
          <div
            className={`d-flex flex-column align-items-start justify-content-center box ${
              defaultWeightUnit === WEIGHT_UNIT.GM ? 'selected' : ''
            }`}
            onClick={() => handleSelect(WEIGHT_UNIT.GM, getSettings)}
          >
            <div className={`TextBox d-flex flex-wrap align-items-center`}>
              <div className={`selectionBoxText`}>{intl.formatMessage({id: 'GRAMS'})}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ReportSettingModal}
